export default defineNuxtPlugin(nuxtApp => {
	function getSafeLocalizedField(field, locale, fallback) {
		if (!field || typeof field !== 'object') return fallback
		if (!locale) return field.en ?? field.jp ?? field.ja ?? fallback

		const normalized = String(locale).toLowerCase()
		const short = normalized.split('-')[0]
		const localeCandidates = [normalized, short]

		// Sanity content uses "jp" while i18n locale is "ja" in this project.
		if (short === 'ja') localeCandidates.push('jp')
		if (short === 'jp') localeCandidates.push('ja')

		for (const key of localeCandidates) {
			if (field[key] != null) return field[key]
		}

		return field.en ?? field.jp ?? field.ja ?? fallback
	}

	return {
		provide: { getSafeLocalizedField }
	}
})
